import React from 'react';
import { GenericPaginatedDocument } from '@/components/print/GenericPaginatedDocument';
import { buildIpcPaymentApplicationPrintModel } from '@/utils/epcIpcPrint';

export type PrintableIpcPaymentApplicationProps = {
  application: Record<string, unknown>;
  contract?: Record<string, unknown>;
  customerName?: string;
  projectLabel?: string;
  onClose?: () => void;
};

export const PrintableIpcPaymentApplication: React.FC<PrintableIpcPaymentApplicationProps> = ({
  application,
  contract,
  customerName,
  projectLabel,
  onClose,
}) => {
  const model = buildIpcPaymentApplicationPrintModel({
    application,
    contract,
    customerName,
    projectLabel,
  });

  return <GenericPaginatedDocument model={model} onClose={onClose} />;
};

export default PrintableIpcPaymentApplication;
